import { render, staticRenderFns } from "./RelocChildrenInfo.vue?vue&type=template&id=4738b0be&scoped=true"
import script from "./RelocChildrenInfo.vue?vue&type=script&lang=ts"
export * from "./RelocChildrenInfo.vue?vue&type=script&lang=ts"
import style0 from "./RelocChildrenInfo.vue?vue&type=style&index=0&id=4738b0be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4738b0be",
  null
  
)

export default component.exports